import { useTranslation } from 'react-i18next';

export type TerminalStatus = keyof ReturnType<typeof useLifecycleStatus>;

export const LIFECYCLE_STATUS = {
    ACTIVE: 'ACTIVE',
    PENDING: 'PENDING',
    EXPIRED: 'EXPIRED',
};

export const useLifecycleStatus = () => {
    const { t } = useTranslation();
    return {
        ACTIVE: t('STATUS.ACTIVE'),
        PENDING: t('STATUS.PENDING'),
        EXPIRED: t('STATUS.EXPIRED'),
    };
};

export const LIFECYCLE_STATUS_COLOR: Record<
    string,
    'success' | 'error' | 'default' | 'primary' | 'secondary' | 'info' | 'warning'
> = {
    ACTIVE: 'success',
    PENDING: 'info',
    EXPIRED: 'warning',
};

export const useFilterSelectOptions = () => {
    const lifecycleStatus = useLifecycleStatus();

    return Object.keys(lifecycleStatus).map((status) => ({
        value: status,
        label: lifecycleStatus[status],
    }));
};
